export default {
  common: {
    nav: {
      home: "ホーム",
      find_offer_help: "助けを探す / 提供する",
      celebrate: "人生を称える",
      family_tree: "家系図",
      events: "イベント",
      civic_reports: "市民レポート",
      neighborhood_pulse: "地域の鼓動",
      weather: "天気",
      nature: "自然",
      marketplace: "マーケット",
      news: "ニュース",
      causes: "支援活動",
      more: "その他",
    },
    header: { sign_in: "サインイン", join: "Social Pulseに参加", language: "言語", search: "検索" },
    tagline: "コミュニティをつなぐ · 生活を支える · 社会資本を築く",
    locality: { viewing_from: "現在の閲覧地域", change: "変更", set_your_location: "場所を設定" },
    news: { title: "今日のブリーフィング。", play_briefing: "デイリーブリーフィングを再生", listen: "聞く", translate: "翻訳" },
  },
};
